// test2776
(2776 && 0);
